import { ref, type Ref } from "vue";
import router from "@/router";

type Direction = "forward" | "back";

const FORWARD = "page-forward";
const BACK = "page-back";

const transitionName = ref<string>(FORWARD);

let initialized = false;

/**
 * Определяет направление навигации, чтобы страницы разъезжались "по стрелке":
 * вперёд — новый экран приходит справа, назад — слева.
 *
 * Vue Router кладёт в history.state порядковый номер записи (position).
 * Сравнение номеров — единственный надёжный способ отличить router.back()
 * и системную кнопку "назад" от обычного push.
 */
const readPosition = (state: unknown): number => {
  const position = (state as { position?: unknown } | null)?.position;
  return typeof position === "number" ? position : 0;
};

export function useRouteTransition(): Ref<string> {
  if (initialized) return transitionName;
  initialized = true;

  let previousPosition = readPosition(window.history.state);

  router.afterEach(() => {
    const currentPosition = readPosition(window.history.state);
    const direction: Direction =
      currentPosition < previousPosition ? "back" : "forward";

    previousPosition = currentPosition;
    transitionName.value = direction === "back" ? BACK : FORWARD;
  });

  return transitionName;
}
